import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getSiguienteSku } from '../../api.wms.productos';
import { Info } from 'lucide-react';
// import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`mui-tabpanel-${index}`}
      aria-labelledby={`mui-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

const ProductModal = ({ producto, onClose, onSave, clientes }) => {
  const [form, setForm] = useState({
    cuenta_id: '', codigo_producto: '', descripcion: '', peso_kg: '', volumen_m3: '', familia: '', unidad_medida: '', activo: true, observaciones: '',
    color: '', talla: '', presentacion: '', capacidad: '', modelo: '', alto: '', ancho: '', largo: '', codigo_barras: '', sku_cliente: '',
    piezas_por_tarima: '', piezas_por_caja: '', piezas_por_paquete: ''
  });
  const [tallaTipo, setTallaTipo] = useState('letras');
  const [tab, setTab] = useState(0);
  const tallasLetras = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];
  const tallasNumeros = ['26', '28', '30', '32', '34', '36', '38', '40', '42', '44'];
  const coloresEstandar = [
    'Blanco', 'Negro', 'Rojo', 'Azul', 'Verde', 'Amarillo', 'Naranja', 'Rosa', 'Morado', 'Gris', 'Marrón', 'Beige', 'Celeste', 'Violeta', 'Dorado', 'Plateado', 'Transparente', 'Otro'
  ];
  const unidadesMedida = ['pieza', 'caja', 'bolsa', 'tarima', 'paquete'];

  useEffect(() => {
    if (producto) setForm({
      color: '', talla: '', presentacion: '', capacidad: '', modelo: '', alto: '', ancho: '', largo: '',
      piezas_por_tarima: '', piezas_por_caja: '', piezas_por_paquete: '',
      ...producto
    });
    else {
      getSiguienteSku()
        .then(sku => {
          setForm({ cuenta_id: '', codigo_producto: sku, descripcion: '', peso_kg: '', volumen_m3: '', familia: '', unidad_medida: '', activo: true, observaciones: '', color: '', talla: '', presentacion: '', capacidad: '', modelo: '', alto: '', ancho: '', largo: '', codigo_barras: '', sku_cliente: '', piezas_por_tarima: '', piezas_por_caja: '', piezas_por_paquete: '' });
        })
        .catch(() => {
          setForm({ cuenta_id: '', codigo_producto: '', descripcion: '', peso_kg: '', volumen_m3: '', familia: '', unidad_medida: '', activo: true, observaciones: '', color: '', talla: '', presentacion: '', capacidad: '', modelo: '', alto: '', ancho: '', largo: '', codigo_barras: '', sku_cliente: '', piezas_por_tarima: '', piezas_por_caja: '', piezas_por_paquete: '' });
        });
    }
  }, [producto]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    // Limpiar campos numéricos opcionales
    const limpiarInt = v => v === '' ? null : parseInt(v, 10);
    const limpiarFloat = v => v === '' ? null : parseFloat(v);
    const limpiarStr = v => v === '' ? null : v;
    onSave({
      cuenta_id: Number(form.cuenta_id),
      codigo_producto: form.codigo_producto, // obligatorio
      descripcion: form.descripcion, // obligatorio
      familia: limpiarStr(form.familia),
      unidad_medida: form.unidad_medida, // obligatorio
      activo: form.activo,
      observaciones: limpiarStr(form.observaciones),
      color: limpiarStr(form.color),
      talla: limpiarStr(form.talla),
      presentacion: limpiarStr(form.presentacion),
      capacidad: limpiarStr(form.capacidad),
      modelo: limpiarStr(form.modelo),
      alto: limpiarStr(form.alto),
      ancho: limpiarStr(form.ancho),
      largo: limpiarStr(form.largo),
      codigo_barras: limpiarStr(form.codigo_barras),
      sku_cliente: limpiarStr(form.sku_cliente),
      piezas_por_tarima: limpiarInt(form.piezas_por_tarima),
      piezas_por_caja: limpiarInt(form.piezas_por_caja),
      piezas_por_paquete: limpiarInt(form.piezas_por_paquete),
      peso_kg: limpiarFloat(form.peso_kg),
      volumen_m3: limpiarFloat(form.volumen_m3)
    });
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <form className="bg-white p-6 rounded-xl shadow-lg w-full max-w-2xl" onSubmit={handleSubmit}>
        <h2 className="text-2xl font-bold mb-4 text-blue-800">{producto ? 'Editar producto' : 'Nuevo producto'}</h2>
        <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" aria-label="tabs producto" sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tab label="Identificación" id="mui-tab-0" aria-controls="mui-tabpanel-0" />
          <Tab label="Características" id="mui-tab-1" aria-controls="mui-tabpanel-1" />
          <Tab label="Presentación y dimensiones" id="mui-tab-2" aria-controls="mui-tabpanel-2" />
          <Tab label="Unidades y conversiones" id="mui-tab-3" aria-controls="mui-tabpanel-3" />
          <Tab label="Otros datos" id="mui-tab-4" aria-controls="mui-tabpanel-4" />
        </Tabs>
        <TabPanel value={tab} index={0}>
          {/* Identificación */}
          <h3 className="text-lg font-bold mb-2 mt-2 text-blue-700">Identificación</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Cliente</label>
              <select name="cuenta_id" value={form.cuenta_id} onChange={handleChange} className="border rounded px-2 py-1 w-full" required>
                <option value="">Selecciona cliente</option>
                {clientes && clientes.map(c => (
                  <option key={c.id} value={c.id}>{c.nombre}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">SKU</label>
              <input name="codigo_producto" value={form.codigo_producto} readOnly placeholder="SKU" className="border rounded px-2 py-1 w-full bg-gray-100 cursor-not-allowed" required />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">SKU cliente</label>
              <input name="sku_cliente" value={form.sku_cliente || ''} onChange={handleChange} placeholder="SKU alternativo del cliente" className="border rounded px-2 py-1 w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Código de barras</label>
              <input name="codigo_barras" value={form.codigo_barras || ''} onChange={handleChange} placeholder="UPC/EAN" className="border rounded px-2 py-1 w-full" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Descripción</label>
              <input name="descripcion" value={form.descripcion} onChange={handleChange} placeholder="Descripción" className="border rounded px-2 py-1 w-full" required />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Familia</label>
              <input name="familia" value={form.familia} onChange={handleChange} placeholder="Familia" className="border rounded px-2 py-1 w-full" />
            </div>
          </div>
        </TabPanel>
        <TabPanel value={tab} index={1}>
          {/* Características */}
          <h3 className="text-lg font-bold mb-2 mt-2 text-blue-700">Características</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Color</label>
              <select
                name="color"
                value={coloresEstandar.includes(form.color) ? form.color : (form.color ? 'Otro' : '')}
                onChange={e => {
                  if (e.target.value === 'Otro') {
                    setForm(f => ({ ...f, color: '' }));
                  } else {
                    setForm(f => ({ ...f, color: e.target.value }));
                  }
                }}
                className="border rounded px-2 py-1 w-full"
              >
                <option value="">Selecciona color</option>
                {coloresEstandar.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
              {((coloresEstandar.includes(form.color) ? form.color : (form.color ? 'Otro' : '')) === 'Otro') && (
                <input
                  name="color"
                  value={form.color}
                  onChange={handleChange}
                  placeholder="Especifica el color"
                  className="border rounded px-2 py-1 w-full mt-2"
                />
              )}
            </div>
            <div>
              <div className="flex items-center justify-between mb-1">
                <label className="block text-sm font-medium">Talla</label>
                <div className="flex items-center gap-2">
                  <span className={tallaTipo === 'letras' ? 'font-semibold text-blue-700' : 'text-gray-500'}>Letras</span>
                  <button type="button" onClick={() => setTallaTipo(tallaTipo === 'letras' ? 'numerico' : 'letras')} className="relative inline-flex h-5 w-10 items-center rounded-full bg-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition ${tallaTipo === 'numerico' ? 'translate-x-5' : 'translate-x-1'}`}></span>
                  </button>
                  <span className={tallaTipo === 'numerico' ? 'font-semibold text-blue-700' : 'text-gray-500'}>Numérico</span>
                </div>
              </div>
              <select
                name="talla"
                value={form.talla}
                onChange={handleChange}
                className="border rounded px-2 py-1 w-full"
              >
                <option value="">Selecciona talla</option>
                {(tallaTipo === 'letras' ? tallasLetras : tallasNumeros).map(t => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Modelo</label>
              <input name="modelo" value={form.modelo} onChange={handleChange} placeholder="Modelo" className="border rounded px-2 py-1 w-full" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Observaciones</label>
              <textarea name="observaciones" value={form.observaciones} onChange={handleChange} placeholder="Observaciones" className="border rounded px-2 py-1 w-full min-h-[48px]" />
            </div>
          </div>
        </TabPanel>
        <TabPanel value={tab} index={2}>
          {/* Presentación y dimensiones */}
          <h3 className="text-lg font-bold mb-2 mt-2 text-blue-700">Presentación y dimensiones</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Presentación</label>
              <input name="presentacion" value={form.presentacion} onChange={handleChange} placeholder="Presentación" className="border rounded px-2 py-1 w-full" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Capacidad</label>
              <input name="capacidad" value={form.capacidad} onChange={handleChange} placeholder="Capacidad (ej: 500 ml, 1 L, 5 kg)" className="border rounded px-2 py-1 w-full" />
            </div>
          </div>
          <div className="md:col-span-2 flex gap-2 mt-2">
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1">Alto</label>
              <input name="alto" value={form.alto} onChange={handleChange} placeholder="Alto" className="border rounded px-2 py-1 w-full" />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1">Ancho</label>
              <input name="ancho" value={form.ancho} onChange={handleChange} placeholder="Ancho" className="border rounded px-2 py-1 w-full" />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1">Largo</label>
              <input name="largo" value={form.largo} onChange={handleChange} placeholder="Largo" className="border rounded px-2 py-1 w-full" />
            </div>
          </div>
        </TabPanel>
        <TabPanel value={tab} index={3}>
          {/* Unidades y conversiones */}
          <h3 className="text-lg font-bold mb-2 mt-2 text-blue-700">Unidades y conversiones</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Unidad de medida</label>
              <select
                name="unidad_medida"
                value={form.unidad_medida}
                onChange={handleChange}
                className="border rounded px-2 py-1 w-full"
                required
              >
                <option value="">Selecciona unidad</option>
                {unidadesMedida.map(u => (
                  <option key={u} value={u}>{u.charAt(0).toUpperCase() + u.slice(1)}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                Peso (kg)
                <span className="relative group cursor-pointer">
                  <Info className="w-4 h-4 text-blue-500" />
                  <span className="absolute left-6 top-1/2 -translate-y-1/2 z-10 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-lg">
                    Ingresa el peso en kilogramos (kg). Ejemplo: 0.25 para 250 gramos.
                  </span>
                </span>
              </label>
              <input name="peso_kg" type="number" value={form.peso_kg} onChange={handleChange} placeholder="Peso (kg)" className="border rounded px-2 py-1 w-full" min="0" step="0.01" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                Volumen (m³)
                <span className="relative group cursor-pointer">
                  <Info className="w-4 h-4 text-blue-500" />
                  <span className="absolute left-6 top-1/2 -translate-y-1/2 z-10 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-lg">
                    Ingresa el volumen en metros cúbicos (m³). Ejemplo: 0.001 para 1 litro (1,000 cm³).
                  </span>
                </span>
              </label>
              <input name="volumen_m3" type="number" value={form.volumen_m3} onChange={handleChange} placeholder="Volumen (m³)" className="border rounded px-2 py-1 w-full" min="0" step="0.0001" />
            </div>
          </div>
          <div className="md:col-span-2 flex gap-2 mt-2">
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                Piezas por tarima
                <span className="relative group cursor-pointer">
                  <Info className="w-4 h-4 text-blue-500" />
                  <span className="absolute left-6 top-1/2 -translate-y-1/2 z-10 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-lg">
                    ¿Cuántas piezas contiene una tarima completa de este producto? (Opcional)
                  </span>
                </span>
              </label>
              <input name="piezas_por_tarima" type="number" min="0" value={form.piezas_por_tarima} onChange={handleChange} placeholder="Ej: 1200" className="border rounded px-2 py-1 w-full" />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                Piezas por caja
                <span className="relative group cursor-pointer">
                  <Info className="w-4 h-4 text-blue-500" />
                  <span className="absolute left-6 top-1/2 -translate-y-1/2 z-10 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-lg">
                    ¿Cuántas piezas contiene una caja de este producto? (Opcional)
                  </span>
                </span>
              </label>
              <input name="piezas_por_caja" type="number" min="0" value={form.piezas_por_caja} onChange={handleChange} placeholder="Ej: 24" className="border rounded px-2 py-1 w-full" />
            </div>
            <div className="flex-1">
              <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                Piezas por paquete
                <span className="relative group cursor-pointer">
                  <Info className="w-4 h-4 text-blue-500" />
                  <span className="absolute left-6 top-1/2 -translate-y-1/2 z-10 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-lg">
                    ¿Cuántas piezas contiene un paquete de este producto? (Opcional)
                  </span>
                </span>
              </label>
              <input name="piezas_por_paquete" type="number" min="0" value={form.piezas_por_paquete} onChange={handleChange} placeholder="Ej: 6" className="border rounded px-2 py-1 w-full" />
            </div>
          </div>
        </TabPanel>
        <TabPanel value={tab} index={4}>
          {/* Otros datos */}
          <h3 className="text-lg font-bold mb-2 mt-2 text-blue-700">Otros datos</h3>
          <div className="flex items-center mt-4">
            <input name="activo" type="checkbox" checked={form.activo} onChange={handleChange} />
            <label className="ml-2 text-sm">Activo</label>
          </div>
        </TabPanel>
        <div className="flex justify-end gap-2 mt-6">
          <button type="button" className="btn-secondary px-4 py-2 rounded" onClick={onClose}>Cancelar</button>
          <button type="submit" className="btn-primary px-4 py-2 rounded">Guardar</button>
        </div>
      </form>
    </div>
  );
};

export default ProductModal;
